import React from 'react';
import { Form, OverlayTrigger, Tooltip, Button,  } from 'react-bootstrap';
import { InfoCircle } from 'react-bootstrap-icons';
import './PickReminderSwitch.css';

function PickReminderSwitch({
    email,
    setCurrDecision,
    currDecision
}) {
    return (
        <>
            <div className='pick-reminder-section'>
                <OverlayTrigger
                    placement='bottom'
                    overlay={
                        <Tooltip id='reminder-button-tooltip-2'>
                            When enabled, you will receive an email reminder to submit your picks at 11:30am CT every Sunday.
                            <br/>
                            <br/>
                            Email: {email}

                        </Tooltip>}
                    >
                    {({ ref, ...triggerHandler }) => (
                        <Button
                        variant='light'
                        {...triggerHandler}
                        className='d-inline-flex align-items-center reminder-tooltip-outline'
                        > 
                        <InfoCircle className='reminder-tooltip-icon' />
                        <span className='reminder-tooltip-display' ref={ref}>Remind Me</span>
                        <Form>
                            <Form.Check
                                // reverse={false}
                                type="switch"
                                id="custom-switch"
                                onChange={setCurrDecision}
                                checked={currDecision}
                            />
                        </Form>
                        </Button>
                    )}

                
                </OverlayTrigger>
            </div>
        </>
    )
};

export default PickReminderSwitch;